module.exports = __webpack_public_path__ + "img/pen.40796807.svg";